const INITIAL_STATE = {
    dash: {},
    loading: false
}

export default function Dashboard(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'DASHBOARD_LOADING' :
            return { ...state, loading: action.payload };
        case 'DASHBOARD_FETCHED' :
            return { ...state, dash: action.payload };
        default :
            return state
    }
}